const genUuid = require('uuid-random') as () => string; // tslint:disable-line:no-var-requires

export function hexUuid(): string {
  return genUuid().replace(/-/g, '');
}

export function emptyNull(v: string): string | null {
  if (v.trim().length === 0) {
    return null;
  }
  return v.trim();
}

export function diffOrNull(v: string, v2: string): string | null {
  if (v.trim() === v2.trim()) {
    return null;
  }
  return v.trim();
}

export const promiseSerial = (funcs) =>
  funcs.reduce(
    (promise, func) =>
      promise.then((result) =>
        func().then(Array.prototype.concat.bind(result))
      ),
    Promise.resolve([])
  );

export function getAcceptedMimeTypes(extraExtensions: string): string[] {
  const mimeMap: Record<string, string> = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    heic: 'image/heic',
    heif: 'image/heif',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    csv: 'text/csv',
    zip: 'application/zip',
  };

  const defaultMimeTypes = ['application/pdf', 'image/jpeg'];
  if (!extraExtensions) {
    return defaultMimeTypes;
  }

  const mimes = [...defaultMimeTypes];
  extraExtensions.split(',').forEach((ext) => {
    const cleanExt = ext.trim().toLowerCase();
    if (mimeMap[cleanExt] && !mimes.includes(mimeMap[cleanExt])) {
      mimes.push(mimeMap[cleanExt]);
    }
  });

  return mimes;
}

export function getAcceptedLabel(extraExtensions: string): string {
  const defaultLabel = 'pdf/jpg';
  if (!extraExtensions) {
    return defaultLabel;
  }
  const extensions = extraExtensions
    .split(',')
    .map((e) => e.trim().toLowerCase());
  return [defaultLabel, ...extensions].join('/');
}
